import { Pipe, PipeTransform } from "@angular/core";
import {SistemaService} from '../Servicios/Sistema.Service';

@Pipe(
  {
    name: 'catalogoPorCatalogo',
    pure: true
  })

export class GetCatalogoDeCatalgoPipe implements PipeTransform
{
  constructor()
  {
  }

  transform(catalogSecundatrio : Array<any>, valorPrincipal : any,  atributoBuscar : string)
  {
    if (!catalogSecundatrio || !valorPrincipal || !atributoBuscar)
    {
      return [];
    }

    let itemsSeleccionados = catalogSecundatrio;

    itemsSeleccionados = catalogSecundatrio.filter((item : any) =>
    {
      return item[atributoBuscar] == valorPrincipal;
    });

    return itemsSeleccionados;
  }
}
